import {Component, QueryList, ViewChildren} from '@angular/core';
import {KpiService} from "../../services/KpiService";
import {AuthService} from "../../services/AuthService";
import {apiconfig} from "../../app/api.config";
import {OperationService} from "../../services/OperationService";
import {
  AreaQuotaBudgetConsumptionReport,
  BudgetQuotaConsumptionReport,
  OperationBudgetConsumptionReport
} from "../../model/CustomerSectorHourQuotaReport";
import {OperationCard} from "../../model/OperationCard";
import {AlertController, NavParams} from "ionic-angular";
import {HomeKpi} from "../../model/HomeKpi";
import {LocupaChartsServiceProvider} from "../../providers/locupa-charts-service/locupa-charts-service";


export class SelectItem {
  label: string;
  value: number;
}

/**
 * Generated class for the ge page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-quota-budget',
  templateUrl: 'quota-budget.html',
})
export class QuotaBudgetPage {

  @ViewChildren('chartCanvas') charts: QueryList<any>;

  /**
   * simple flag to dislpay spinning / waiting wheel
   */
  uiloading: boolean = false;


  apiConfig: any = apiconfig;

  private uiToggleSecondayMenuBar: boolean;

  private focusedOperation: OperationCard;
  private uiOperationReport: BudgetQuotaConsumptionReport;
  private uiOperationCardsById: OperationCard[] = [];

  private opKpi: HomeKpi[];


  // we have a simple map of ifs for each KPI that have been rendered to prevent from excessive loops
  private kpiAlreadyRendered: boolean[] = [];


  // -- variable to manager Quota transfert ---

  /**
   * flag to tell if we are currently re-allocating quota
   */
  uiReAllocateQuotaToggle: boolean[] = [];

  /**
   * flag to tell if we are currently display any zone for dispatch
   */
  uiDispatchQuotaToggle: boolean[] = [];
  /**
   * quantity to dispatch in sectors
   */
  uiDispatchQty: number[] = [];

  /**
   * are we ok to display the submit button for sending dispatch request
   */
  uiShowDispatchSubmitButton: boolean;


  // warning when we can't proceed to quota re-allocation
  uiDispatchWarnings: string[][] = [];


  // selected sector as source / from
  uiReallocateQuotaSectorFromId: any;

  // selected sector as destinatinon/ to
  uiReallocateQuotaSectorToId: any;

  // max allowable quantity baed on from selection
  uiReAllocateQuotaMaxQty: number;

  // allocated quantity
  uiReAllocateQuotaQty: any;

  // cache for sectors available as source
  sourceSectors: SelectItem[];

  // cache for sectors available as destination
  destSectors: SelectItem[];

  // warning when we can't proceed to quota re-allocation
  uiReAllocateWarnings: string[][] = [];

  // link to use to download a file
  private uiCurrentDownloadLink: string;

  // enabling the quota transfer mode
  private uiToggleReallocateQuotaMode: boolean;

// -- page title based on quota euro/points
  uiPageTitle: string;

  // --

  constructor(private kpiService: KpiService,
              private authService: AuthService,
              public navParams: NavParams,
              private locupaChartsServiceProvider: LocupaChartsServiceProvider,
              private alertCtrl: AlertController,
              private operationService: OperationService) {
  }

  ionViewDidEnter() {

    this.focusedOperation = this.navParams.get('operationCard');

    this.uiOperationCardsById = [];
    this.uiloading = true;

    this.uiPageTitle = "Suivi des Quota";
    if (this.focusedOperation != null) {
      if (this.focusedOperation.budgetQuotaInPoints)
        this.uiPageTitle = "Suivi des Quota En points";
      else
        this.uiPageTitle = "Suivi des Quota en Euros";
    }

    this.repaintKpiPage();
  }


  private repaintKpiPage() {
    this.kpiService.loadBUdgetQuotaReport(this.focusedOperation == null ? null : this.focusedOperation.id).then(
      (report: BudgetQuotaConsumptionReport) => {

        // let's sort operation cards, let's use the id to be sure we have always something stable
        if (report.operationReports != null)
          report.operationReports.sort((a, b) => {
            return a.operation.id - b.operation.id;
          });
        this.opKpi = [];

        this.uiOperationReport = report;
        if (this.focusedOperation != null) {

          this.uiOperationCardsById[this.focusedOperation.id] = this.focusedOperation;

          let filtered = [];

          report.operationReports.forEach(op => {
            if (op.operation.id == this.focusedOperation.id) {
              filtered.push(op);
            }
          })
          report.operationReports = filtered;
          this.buildGlobalOperationKnobChart();
          this.uiloading = false;

        } else {
          this.operationService.loadOperationCards().then((cards) => {
            cards.forEach(c => this.uiOperationCardsById[c.id] = c);
            this.buildGlobalOperationKnobChart();
            this.uiloading = false;
            console.log("Operation cards loaded, ready to display");
            console.log(cards);
          });
        }


        this.charts.changes.subscribe(() => this.charts.toArray().forEach(
          (item) => {
            let opIdAndKpiType: string = item.nativeElement.id.split('|');
            if (opIdAndKpiType.length === 2) {
              let kpiId = opIdAndKpiType[1];

              //skip this to prevent from flickering, we don't want to repaint this continuously
              if (this.kpiAlreadyRendered[kpiId]) return;

              this.opKpi.forEach(hkpi => {
                if (hkpi.id == kpiId) {
                  this.locupaChartsServiceProvider.buildHomeKpiChart(hkpi, item);
                  this.kpiAlreadyRendered[kpiId] = true;
                }
              });
            }
          }));
      }
    )
  }

  private buildGlobalOperationKnobChart() {
    if (this.uiOperationReport != null && this.uiOperationReport.operationReports != null) {

      this.uiOperationReport.operationReports.forEach(opR => {

        console.log(opR);

        let isFieldTeam = this.authService.loggedUser.hierarchicalNature === 'FIELDTEAM';
        if (isFieldTeam) {

          if (opR.globalQuota == null || opR.globalQuota <= 0) return;

          let kpi = new HomeKpi();
          kpi.id = 'kpi_' + opR.operation.id;
          kpi.title = 'Rapport Global';
          kpi.homeKpiType = 'STACKBARQuota';
          kpi.xs = 6;
          kpi.sm = 6;
          kpi.md = 6;
          kpi.lg = 6;

          let delta = Math.round(opR.globalQuota - opR.consumedQuota);

          if (delta >= 0) {
            kpi.colors = ["purple", "green"];
            kpi.labels = ['Planifié', 'Disponible'];
            kpi.values = [Math.round(opR.consumedAndPlannedQuota), delta];
          } else {
            kpi.colors = ["purple", "red"];
            kpi.labels = ['Planifié', 'Dépassement'];
            kpi.values = [Math.round(opR.globalQuota), -delta];
          }

          this.opKpi.push(kpi);
        }

        if (this.authService.loggedUser.hierarchicalNature != null && opR.globalReportLine != null) {

          let gLine = opR.globalReportLine;

          let kpi = new HomeKpi();
          kpi.id = 'kpi_g_' + opR.operation.id;
          kpi.title = 'Synthèse Imputation Secteurs';
          kpi.homeKpiType = 'STACKBARQuota';
          kpi.xs = 12;
          kpi.sm = 12;
          kpi.md = isFieldTeam ? 6 : 12;
          kpi.lg = isFieldTeam ? 6 : 12;

          if (gLine.availableQuota > 0) {
            kpi.colors = ["lightblue", "purple", "green"];
            kpi.labels = ['Réalisé', 'Planifié', 'Restant'];
            kpi.values = [Math.round(gLine.consumedAndRealisedQuota), Math.round(gLine.consumedAndPlannedQuota - gLine.consumedAndRealisedQuota), Math.round(gLine.availableQuota)];
          } else {
            kpi.colors = ["lightblue", "purple", "red"];
            kpi.labels = ['Réalisé', 'Planifié', 'Depassement'];
            kpi.values = [Math.round(gLine.consumedAndRealisedQuota), Math.round(gLine.consumedAndPlannedQuota - gLine.consumedAndRealisedQuota), Math.round(gLine.availableQuota)];
          }
          this.opKpi.push(kpi);
        }


      });
    }
  }

  private repaintAfterQuotaUpdate() {
    this.uiOperationCardsById = [];
    this.kpiAlreadyRendered = [];
    this.uiReAllocateQuotaToggle = [];
    this.uiDispatchQuotaToggle = [];
    this.uiToggleReallocateQuotaMode = false;
    this.repaintKpiPage();
  }

  /**
   *
   */
  displayGlobalReportLine(opReport: OperationBudgetConsumptionReport): boolean {
    //check if null or not defined
    if (opReport == null || opReport.globalReportLine == null) return false;
    //check if there is more than 1 areas, if one only, makes no sense to show global
    if (opReport.areas != null && opReport.areas.length == 1) return false;
    return true;
  }

  /**
   * request for XLS report computation online, and then display the download link.
   * @param id
   */
  downloadQuotaExtract(id: number) {
    this.kpiService.loadXlsBudgetQuotaReport(id).then(uuid => {
      this.uiCurrentDownloadLink = uuid;
      console.log(uuid);
    });
  }

  /**
   * display the quota re-allocation section, and reset working variables
   * @param areaReport
   * @param b
   */
  showReallocateQuota(opReport: OperationBudgetConsumptionReport, areaReport: AreaQuotaBudgetConsumptionReport, b: boolean) {
    if (b) {
      // reset to neutral -- nothing selected
      // useful if another area was chosen
      this.uiReallocateQuotaSectorFromId = null;
      this.uiReallocateQuotaSectorToId = null;
      this.uiReAllocateQuotaQty = 0;
      this.uiReAllocateQuotaMaxQty = 0;
      this.sourceSectors = [];
      this.destSectors = [];

      //hide the dispatch section in case it's open, it would be misleading from UX perspective to have both
      this.uiDispatchQuotaToggle[areaReport.area.id] = false;

      this.reprocessReallocateQuota(opReport, areaReport);
    }
    this.uiReAllocateQuotaToggle[areaReport.area.id] = b;
  }

  /**
   * reprocess selectors
   * @param area
   */
  reprocessReallocateQuota(opReport: OperationBudgetConsumptionReport, area: AreaQuotaBudgetConsumptionReport) {
    if (this.uiReallocateQuotaSectorFromId == null)
      this.sourceSectors = this.findSourceSectors(opReport, area);
    if (this.uiReallocateQuotaSectorToId == null)
      this.destSectors = this.findDestSectors(opReport, area);
  }


  /**
   * convenient method to find out sources for sectors
   * @param area
   */
  findSourceSectors(opReport: OperationBudgetConsumptionReport, area: AreaQuotaBudgetConsumptionReport): SelectItem[] {
    console.log('findSourceSectors');
    const sectors: SelectItem[] = [];
    area.sectors.forEach(sect => {

      if (sect.availableQuota != null && sect.availableQuota > 0) {
        const i = new SelectItem();

        if (opReport.euroToPointQuotaRate)
          i.label = sect.customerSector.name + " (disponible : " + sect.availableQuota.toFixed(0) + 'points )';
        else
          i.label = sect.customerSector.name + " (disponible : " + sect.availableQuota.toFixed(2) + '€ )';
        i.value = sect.customerSector.id;
        sectors.push(i);
      }
    })
    return sectors;
  }

  /**
   * find the sectors we can select as destinations
   * @param area
   */
  findDestSectors(opReport: OperationBudgetConsumptionReport, area: AreaQuotaBudgetConsumptionReport) {
    console.log('findDestSectors');
    const sectors: SelectItem[] = [];
    area.sectors.forEach(sect => {
      if (sect.customerSector.id == this.uiReallocateQuotaSectorFromId) {
        this.uiReAllocateQuotaMaxQty = sect.availableQuota;
      } else {
        // this is not a source sector, we can suggest it in the destinations
        const i = new SelectItem();
        i.label = sect.customerSector.name;
        i.value = sect.customerSector.id;
        sectors.push(i);
      }
    })
    return sectors;
  }

  /**
   *
   * @param areaQuotaConsumptionReport
   * @param operationId
   */
  submitReAllocateRequest(areaQuotaConsumptionReport: AreaQuotaBudgetConsumptionReport, operationId: number) {

    // reset the warnings as we are about to send a new request to the API
    this.uiReAllocateWarnings[areaQuotaConsumptionReport.area.id] = [];

    this.operationService.submitQuotaBudgetTransfer(operationId, this.uiReallocateQuotaSectorFromId, this.uiReallocateQuotaSectorToId, this.uiReAllocateQuotaQty)
      .then(actionDone => {

        this.uiloading = true;

        if (actionDone.success) {
          this.repaintAfterQuotaUpdate();
        } else {
          this.uiloading = false;
          this.uiReAllocateWarnings[areaQuotaConsumptionReport.area.id] = actionDone.warnings;
        }

      }).catch(err => {
      console.log('Error during quota submit');
      console.log(err);

      let alert = this.alertCtrl.create({
        title: 'Erreur Technique - Transfert impossible',
        message: 'Erreur technique, veuillez contacter votre interlocuteur agence',
        buttons: ['Fermer'],
        cssClass: 'alertDanger'
      });

      return alert.present();
    });
  }

  /**
   *
   * @param area
   * @param b
   */
  showDispatchQuota(area: AreaQuotaBudgetConsumptionReport) {

    let enableDispatch = !this.uiDispatchQuotaToggle[area.area.id];
    this.uiDispatchQuotaToggle[area.area.id] = enableDispatch;

    if (enableDispatch) {
      // it would be confusing from a UX perspective to have both show at once
      this.uiReAllocateQuotaToggle[area.area.id] = false;
    }

    // initialise with 0 values for sectors of the current area
    this.uiDispatchQty = [];
    if (area != null) {
      for (let s of area.sectors) {
        this.uiDispatchQty[s.customerSector.id] = 0;
      }
    }

  }

  /**
   *
   * @param area
   */
  reprocessDispatchQuota(area: AreaQuotaBudgetConsumptionReport) {
    let remaining = area.quotaRemainingToDispatchInSectors;
    for (let s of area.sectors) {
      if (this.uiDispatchQty[s.customerSector.id])
        remaining -= this.uiDispatchQty[s.customerSector.id];
    }
    console.log("remaining quota" + remaining);
    this.uiShowDispatchSubmitButton = remaining > 0;
  }

  /**
   *
   * @param areaQuotaConsumptionReport
   * @param operationId
   */
  submitDispatchInSectorsRequest(areaQuotaConsumptionReport: AreaQuotaBudgetConsumptionReport, operationId: number) {

    // reset the warnings as we are about to send a new request to the API
    this.uiDispatchWarnings[areaQuotaConsumptionReport.area.id] = [];

    let qty: { sector: number, quotaQuantity: number }[] = [];
    for (let s of areaQuotaConsumptionReport.sectors) {
      if (this.uiDispatchQty[s.customerSector.id]) {
        qty.push({sector: s.customerSector.id, quotaQuantity: this.uiDispatchQty[s.customerSector.id]})
      }
    }

    this.operationService.submitQuotaBudgetToDispatch(operationId, areaQuotaConsumptionReport.area.id, qty)
      .then(actionDone => {
        this.uiloading = true;

        if (actionDone.success) {
          this.repaintAfterQuotaUpdate();
        } else {
          this.uiloading = false;
          this.uiDispatchWarnings[areaQuotaConsumptionReport.area.id] = actionDone.warnings;
        }

      }).catch(err => {
      console.log('Error during quota submit');
      console.log(err);

      let alert = this.alertCtrl.create({
        title: 'Erreur Technique - Transfert impossible',
        message: 'Erreur technique, veuillez contacter votre interlocuteur agence',
        buttons: ['Fermer'],
        cssClass: 'alertDanger'
      });

      return alert.present();
    });
  }

  toogleOffQuotaDetails(opReport: OperationBudgetConsumptionReport) {
    opReport.uiDisplayOffQuotaDetails = !opReport.uiDisplayOffQuotaDetails;
  }
}



// WEBPACK FOOTER //
// ./src/pages/quota/quota-budget.ts